module.exports = __webpack_public_path__ + "img/partners8.3f4281b1.png";